import InputAdornment from "@mui/material/InputAdornment/InputAdornment";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField/TextField";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Box from "@mui/material/Box";
import dashboardService from '../../../services/hoa-dashboard-api-service';

import { Search, LinkOff } from "@mui/icons-material";
import React, { useEffect, useState, useContext } from "react";
import { IconButton, LinearProgress, Tooltip } from "@mui/material";

import { GlobalContext } from '../../../context/hoa-global-context';
import config from '../../../hoa-config';
import datastore from '../../../store/hoa-datastore';
import { saveNewLogsInDatastore } from "../../../utility/change-log";
import LoadingComponent from "../../../components/loading-component/loading-component";

interface PropertiesProps {
	hoaProperties?: any;
	setHoaProperties?: any;
	selectedValues : any,
	height: number;
}

const toolbar = 64;
const filterComponent = 103;
const tabHeader = 48;
const tabHeading = 65;
const tableHeader = 57;
const responsiveHeight = toolbar + filterComponent + tableHeader + tabHeader + tabHeading + 1;

export default function PropertiesComponent(props: PropertiesProps) {
	const {selectedValues, height, hoaProperties, setHoaProperties} = props;
	const [loading, setLoading] = useState(false);
	const [unlinkLoading, setUnlinkLoading] = useState(false);
	const [searchQuery, setSearchQuery] = useState('');
	
	const numberOfProjects = Math.ceil((window.innerHeight - responsiveHeight) / 60)

	useEffect(()=>{
		if(hoaProperties.data.length <= 0 && selectedValues.numberOfProperties > 0) {
			getProperties(hoaProperties.pageNumber);
		}
	},[])

	async function handleScroll(e: any) {
	if (
		!loading &&
		!hoaProperties.isLastPage &&
		hoaProperties.data.length < selectedValues.numberOfProperties
	) {
		const bottom = Math.ceil(e.target.scrollHeight - e.target.scrollTop) <= e.target.clientHeight + 1;
		if (bottom) {
			await getProperties(hoaProperties.pageNumber);
		}
	}
	}


	async function onKeyPress(e: any){
		if (e.key === "Enter") {
			setHoaProperties({
				...hoaProperties,
				data: []
			});
			await getProperties(1, e.target.value);
		}
	}

	async function getProperties(page: number, externalId?: string) {
	if (loading) return; // Prevent multiple simultaneous calls

	// If we've already fetched all properties, don't proceed
	if (hoaProperties.isLastPage) return;

	setLoading(true);

	const { status, data } = await dashboardService.getPropertiesOfHoa(
		selectedValues.objectId,
		numberOfProjects,
		page,
		externalId ?? null,
		datastore.selectedOrganization?.id
	);

	if (status === 200) {
		const isLastPage = data.length < numberOfProjects;

		if (externalId) {
			setHoaProperties({
				data: data,
				pageNumber: 2,
				isLastPage: isLastPage
			});
		} else {
			setHoaProperties((prev: any) => ({
				...prev,
				data: [...prev.data, ...data],
				pageNumber: prev.pageNumber + 1,
				isLastPage: isLastPage
			}));
		}
	}

	setLoading(false);
}


	return (
		<div>
			<LoadingComponent loading={unlinkLoading} />
			<Stack
				padding={"24px"}
				direction={"row"}
				justifyContent={"space-between"}
				alignItems={'center'}
				flexWrap={"wrap"}
				borderBottom={"1px solid #E8E8E8"}
			>
				<Stack direction={"column"}>
					<Box component={'span'} className="text-787878-14px bold">No of Properties: {selectedValues.numberOfProperties}</Box>
				</Stack>
				<Stack>
					<SearchFieldContainer searchQuery={searchQuery} setSearchQuery = {setSearchQuery} onKeyPress={onKeyPress}/>
				</Stack>
			</Stack>
			{loading ? <LinearProgress style={{ height: "2px", position: 'sticky', top: 0}} /> : null}
			<TableContainer hoaProperties={hoaProperties} setHoaProperties={setHoaProperties} loading={loading} setLoading={setLoading} height={height} handleScroll={handleScroll} unlinkLoading={unlinkLoading} setUnlinkLoading={setUnlinkLoading}/>
		</div>
	);
}

const TableContainer = ({hoaProperties, setHoaProperties, loading, setLoading, height, handleScroll, unlinkLoading, setUnlinkLoading} : any) => {
	const { selectedValues, updateSelectedValues, changeActiveMenu,  hoa, updateHoaData, property, updatePropertyData} = useContext<any>(GlobalContext);

	const getFormattedDate = (dateText:string)=>{
		if(dateText) {
			const date = new Date(dateText);
			return date.toLocaleDateString();
		}
		else {
			return "N/A"
		}

	}
	const defaultNoDataContainer = () => {
		return (
			<Stack direction={"column"} justifyContent={"center"} alignItems={"center"}>
				<img width={"250px"} src="images/logo/property-default.png" />
				<Box component={'span'} className="text-787878-16px bold">No Property Found</Box>
				<Box component={'span'} sx={{ maxWidth:'320px', mt:'8px'}} className="text-787878-14px normal">
					No property has been added for this HOA yet. Please add property for this HOA to
					view in the list.
				</Box>
			</Stack>
		);
	};

	const openPropertyView = (property: any) => {
		if(!property) {
			return;
		}

		updateSelectedValues(property);
		changeActiveMenu("Properties", true);
	}

	function MouseOver(event: any) {
        event.target.style.color = '#3576E5';
    }
    function MouseOut(event: any) {
        event.target.style.color = "";
    }

	const updateLocalHoaInfo = (id:string, numberOfProperties:number) => {
		const index = hoa.data.findIndex((hoa_v:any) => hoa_v.objectId === id)
		if(index >= 0){
			let tmpHoaData = hoa.data;
			tmpHoaData[index].numberOfProperties = numberOfProperties;
			
			updateHoaData({
				...hoa,
				data:tmpHoaData
			})
		}

		if (selectedValues.objectId == id) {
			const selectedValuesCopy = JSON.parse(JSON.stringify(selectedValues));
			selectedValuesCopy.numberOfProperties = numberOfProperties;
			updateSelectedValues(selectedValuesCopy);
		}
	}

	const onIconBtnClick = async (e: any, data:any, tagType?:any) => {
		setLoading(true);
		setUnlinkLoading(true);
		let propertyData = property.data;
		let index = 0;
		propertyData.find((value: any, index1: number) => {
			if(value.objectId === data.objectId){
				index = index1;
			}
		});
		let propertiesData = hoaProperties.data.filter((value: any) => value.objectId != data.objectId);

		let updatedData = {
			...data,
			name: data.info.street,
			hoaId: '',
			hoaAssignedDate: '',
			hoaPropertyDetails:{
				...data['hoaPropertyDetails'],
				market: '',
			},
			info: {
				...data['info'],
				city: '',
				state: '',
				zip: '',
			},
			_parseObject: {
				...data['_parseObject'],
				hoa: undefined
			}
		}
		const result = await dashboardService.unlinkPropertyFromHoa(updatedData, data.hoaId)
		if(result.data.propertiesNumberOfHOA){
			updateLocalHoaInfo(result.data.propertiesNumberOfHOA.id,result.data.propertiesNumberOfHOA.number);
			if(result.data.propertiesNumberOfHOA?.preid){
				updateLocalHoaInfo(result.data.propertiesNumberOfHOA.preid,result.data.propertiesNumberOfHOA.prenumber);
			}
		}

		const extensions:any = [`(${data?.objectId})`];
		await createLogs('removeProperty', data.hoaId, data, result.data, 'Hoa', extensions);

		let updateLogMessage = {
			hoaId: data.hoaId, 
			event: `${config.changeLongActionsHoa['propertyAssigned']} (${data.objectId})`,
			billItem: 'Not Billable',
			billAmount: 0,
			updatedBy: datastore.ownerInformation.name
		}

		let updateHoaChangeLogResponse = await dashboardService.updateHoaBillItem(updateLogMessage);
		if(updateHoaChangeLogResponse.status == 200 && Array.isArray(updateHoaChangeLogResponse.data)) {
			if(datastore.createdLogs[data.hoaId]) {
				let tempLogs = {...datastore.createdLogs[data.hoaId]};
				tempLogs.data.forEach((log:any) => {
					//updateHoaChangeLogResponse.data is an array of updated logs
					updateHoaChangeLogResponse.data.forEach((element: any) => {
						if(element.objectId == log.objectId) {
							log.billItem = element.billItem;
						}
					});
				});
				datastore.createdLogs[data.hoaId] = tempLogs;
			}	
		}

		if(Array.isArray(hoaProperties.data) && hoaProperties.data.length > 1 
			&& data.objectId == hoaProperties.data[0].objectId) {
			
			updateLogMessage = {
				hoaId: data.hoaId, 
				event: `${config.changeLongActionsHoa['propertyAssigned']} (${hoaProperties.data[1].objectId})`,
				billItem: 'First property addition',
				billAmount: 0,
				updatedBy: datastore.ownerInformation.name
			}

			updateHoaChangeLogResponse = await dashboardService.updateHoaBillItem(updateLogMessage);

			if(updateHoaChangeLogResponse.status == 200 && Array.isArray(updateHoaChangeLogResponse.data)) {
				if(datastore.createdLogs[data.hoaId]) {
					let tempLogs = {...datastore.createdLogs[data.hoaId]};
					tempLogs.data.forEach((log:any) => {
						//updateHoaChangeLogResponse.data is an array of updated logs
						updateHoaChangeLogResponse.data.forEach((element: any) => {
							if(element.objectId == log.objectId) {
								log.billItem = element.billItem;
							}
						});
					});
					datastore.createdLogs[data.hoaId] = tempLogs;
				}	
			}
		}

		propertyData[index] = result.data;
		if (result.status === 200) {
			updatePropertyData({
				...property,
				data: propertyData,
			});
		}
		setHoaProperties({
			...hoaProperties,
			data: propertiesData
		})
		setLoading(false);
		setUnlinkLoading(false);
    }

	const createLogs = async (status:string,objectId:string,prevState?:any,updatedState?:any, type?: string, extensions?: any) => {
		// delete parseObjects
		let prev = {...prevState}
		delete prev._parseObject
		let update = {...updatedState}
		delete update._parseObject

		// set primaryEvent
		var events:any = [];
		var primaryEvent = config.changeLongActionsHoa[status];

		// manage extensions
		if(Array.isArray(extensions) && extensions.length > 0) {
			extensions.map(extension => {
				events.push(`${primaryEvent} ${extension}`);
			});
		}
		else {
			events.push(primaryEvent);
		}

		const logMessage = {
			events:events,
			user: datastore.ownerInformation.name,
			prevState:prev,
			updatedState:update,
			type:type,
			tagTypeId:objectId,
		}

		const result = await dashboardService.createLogs(logMessage);
		saveNewLogsInDatastore(result.data, datastore);
    }

	return (
		<div
	style={{
		height: height - 80,
		overflowY: "auto"
	}}
	onScroll={handleScroll}
>

		{
			hoaProperties.data.length > 0 &&
				<Table stickyHeader>
					<TableHead>
						<TableRow
							sx={{
								"& th": {
									color: "#3E3E3E",
									backgroundColor: "#F7F7F7",
								},
							}}
						>
							{["Property Address", "Organization Name",  "External Id", "Market", "City", "Added On", ""].map(
								(title: string, index: number) => {
									return (
										<TableCell key={index}>
											<span className="text-3E3E3E-14px bold">{title}</span>
										</TableCell>
									);
								}
							)}
						</TableRow>
					</TableHead>
					<TableBody>
						{
							hoaProperties.data.map((property: any, index:number)=>{
								return (
								<TableRow
									sx={{
										"& th": {
											color: "#3E3E3E",
											backgroundColor: "#F7F7F7",
										},
									}}
									key={index}
								>
									<TableCell >
										<a href="#" className="text-3E3E3E-14px bold" onClick={() => openPropertyView(property)}>{property?.fullAddress}</a>
									</TableCell>
									<TableCell >
										<span className="text-3E3E3E-14px bold">{property?.organizationName}</span>
									</TableCell>
									<TableCell >
										<span className="text-3E3E3E-14px bold">{property?.hoaPropertyDetails?.externalId}</span>
									</TableCell>
									<TableCell >
										<span className="text-3E3E3E-14px bold">{property?.hoaPropertyDetails?.market}</span>
									</TableCell>
									<TableCell >
										<span className="text-3E3E3E-14px bold">{property?.info?.city}</span>
									</TableCell>
									<TableCell >
										<span className="text-3E3E3E-14px bold">{getFormattedDate(property?.hoaAssignedDate)}</span>
									</TableCell>
									{
										datastore.userRole != config.userRoles.OrganizationUser ?
											<TableCell>
											<Tooltip title="Unlink Property">
												<IconButton onClick={(e)=>onIconBtnClick(e, property,'view')} onMouseOver={MouseOver} onMouseOut={MouseOut}>
													<LinkOff />
												</IconButton>
											</Tooltip>
											</TableCell>
											: <></>
									}
								</TableRow>)
							})
						}
					</TableBody>
				</Table>
		}
		{
			hoaProperties.data.length === 0 && !loading && defaultNoDataContainer()
		}
		</div>
	);
};

const SearchFieldContainer = ({searchQuery, setSearchQuery, onKeyPress}:any) => {
	const onChangeText = () => {};

	const onEnterKeyPressed = () => {};

	return (
		<TextField
			variant="outlined"
			placeholder="Search by external Id"
			onChange={(e)=>{setSearchQuery(e.target.value)}}
			onKeyDown={onEnterKeyPressed}
			name={"name"}
			style={{ boxSizing: "border-box" }}
			sx={{
				"&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
					borderColor: "#E8E8E8",
				},
				"& .MuiInputBase-root": {
					"&.Mui-focused fieldset": {
						borderColor: "#E8E8E8",
					},
				},
				"& .MuiOutlinedInput-adornedEnd": {
					paddingRight: "0px",
				},
			}}
			InputProps={{
				margin: "none",
				className: "searchInputClass",
				startAdornment: (
					<InputAdornment position="start">
						<Search style={{ color: "#9F9F9F" }} />
					</InputAdornment>
				),
			}}
			type={"search"}
			value={searchQuery}
			onKeyPress={onKeyPress}
		/>
	);
};
